import React, { useEffect, useState } from "react";
import Select from "react-select";
import { AuditAdminData } from "../../data/AuditAdminData";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import {
  Box,
  CircularProgress,
  IconButton,
  Modal,
  Snackbar,
} from "@mui/material";
import "./formComponent.scss";
import { getToken } from "../../auth/authConfig";
import axios from "axios";
import { useRecoilState, useSetRecoilState } from "recoil";
import { protocolType } from "../../../store/audit details/atom";
import { formProgress } from "../../../store/atoms";
import { login } from "../../auth/msalAuth";
import LeadAuditExcel from "../../reusables/LeadAuditExcel";

const FormComponent = () => {
  const [formData, setFormData] = useState({ version: 1 });
  const [formDataDownload, setformDataDownload] = useState({ version: 1 });

  const [rows, setRows] = useState([{ name: "", function: "" }]);
  const [focusAreaField, setFocusAreaField] = useState([""]);
  const [sentBackAuditData, setSentBackAuditData] = useState(null);
  const [sentBackLoading, setSentBackLoading] = useState(false);
  const [sentBackError, setSentBackError] = useState(null);
  const setProtocolType = useSetRecoilState(protocolType);
  const [progressvalue, setFormProgress] = useRecoilState(formProgress);
  const [error, setError] = useState(false);


  const [loading, setLoading] = useState({
    save: false,
    submit: false,
  });
  const [dataLoading, setDataLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [submitDisable, setSubmitDisable] = useState(true);
  const [unitIndex, setUnitIndex] = useState("");
  const [unitDetails, setUnitDetails] = useState([]);


  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const queryParams = new URLSearchParams(window.location.search);
  const auditNumber = queryParams.get("auditNumber");

  if (formData.audit_team && Boolean(Object.keys(formData?.audit_team)[0])) {
    console.log(formData?.audit_team);
  }

  const handleInputChange = (name, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  
    setformDataDownload((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  

  const addRow = () => {
    if (rows.length < 5) {
      setRows([...rows, { name: "", function: "" }]);
    }
  };

  const addFocusAreaRows = () => {
    if (focusAreaField.length < 4) {
      setFocusAreaField([...focusAreaField, ""]);
    }
  };

  const handleRowChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
  };

  const handleFocusAreaChange = (index, value) => {
    const updatedFocusArea = [...focusAreaField];
    updatedFocusArea[index] = value;
    setFocusAreaField(updatedFocusArea);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const checkformDataValues = formData
    ? Boolean(formData.audit_criteria) &&
      Boolean(formData.audit_delivery) &&
      Boolean(formData.audit_end_date) &&
      Boolean(formData.audit_start_date) &&
      Boolean(formData.audit_language) &&
      Boolean(formData.audit_type) &&
      Boolean(formData.lead_auditor) &&
      Boolean(formData.lead_auditor_function) &&
      Boolean(formData.cb_office_location) &&
      Boolean(formData.version) 
      // &&
      // Boolean(formData.jobnumber)
    : false;

  const checkAdditionalAttendies = () => {
    for (let i = 0; i < rows.length; i++) {
      const obj = rows[i];
      if (obj.name && obj.function) {
        return true;
      }
    }
    return false;
  };

  const checkAttendies = checkAdditionalAttendies();


  const submitForm = async (activity) => {
    try {
      if (activity === "saved") {
        setSnackbarMessage("Form Saved Successfully!");
        setLoading((prev) => ({
          ...prev,
          save: true,
        }));
      }
      if (activity === "completed") {
        setSnackbarMessage("Form Submitted Successfully!");
        setLoading((prev) => ({
          ...prev,
          submit: true,
        }));
      }

      // Build audit team object
      const auditTeamObject = rows.reduce((acc, row) => {
        if (row.name && row.function) {
          acc[row.name] = row.function;
        }
        return acc;
      }, {});

      // Build the payload for sent-back audit
      const payload = {
        cb_office_location: String(formData.cb_office_location || ""),
        audit_language: String(formData.audit_language || ""),
        is_fssc_conjunction: formData?.is_fssc_conjunction === true ? true : false,
        audit_criteria: JSON.stringify(formData.audit_criteria || []),
        audit_start_date: String(formData.audit_start_date || ""),
        audit_end_date: String(formData.audit_end_date || ""),
        audit_delivery: String(formData.audit_delivery || ""),
        audit_type: String(formData.audit_type || ""),
        version: String(formData.version || 1),
        corrective_action_date: String(formData.corrective_action_date || ""),
        lead_auditor: String(formData.lead_auditor || ""),
        lead_auditor_function: String(formData.lead_auditor_function || ""),
        audit_focus_area: JSON.stringify(focusAreaField.filter(area => area.trim() !== "") || []),
        additional_attendee: JSON.stringify(auditTeamObject || {})
      };

      let url;
      let token = await getToken();

      if (activity === "saved") {
        // SAVE API for sent-back audit
        url = `${process.env.REACT_APP_SERVER_URL}/api/save-audit/sentback/${auditNumber}`;
        
        const saveResponse = await axios.post(url, payload, {
          headers: {
            "oidc-token": token,
            Accept: "application/json",
          },
        });

        if (saveResponse.status === 200) {
          setOpen(true);
          setLoading((prev) => ({
            ...prev,
            save: false,
          }));
        }
      } else if (activity === "completed") {
        // SUBMIT API for sent-back audit
        url = `${process.env.REACT_APP_SERVER_URL}/api/submit_audit/sentback/${auditNumber}`;
        
        const submitResponse = await axios.post(url, payload, {
          headers: {
            "oidc-token": token,
            Accept: "application/json",
          },
        });

        if (submitResponse.status === 200) {
          setLoading((prev) => ({
            ...prev,
            submit: false,
          }));
          
          // Refresh the page after successful submission
          window.location.reload();
        }
      }
    } catch (error) {
      if (activity === "saved") {
        setLoading((prev) => ({
          ...prev,
          save: false,
        }));
        setSnackbarMessage("Error saving form. Please try again.");
        setOpen(true);
      }
      if (activity === "completed") {
        setLoading((prev) => ({
          ...prev,
          submit: false,
        }));
        setSnackbarMessage("Error submitting form. Please try again.");
        setOpen(true);
      }
      console.error("Error while calling the API:", error);
    }
  };


  // Get sent back audit data with field statuses
  const getSentBackAuditData = async () => {

  
    try {
      setSentBackLoading(true);
      setSentBackError(null);

      const url = `${process.env.REACT_APP_SERVER_URL}/api/sent_back/audit/${auditNumber}`;
      const token = await getToken();

      const response = await axios.get(url, {
        headers: {
          "oidc-token": token,
          Accept: "application/json",
        },
      });

      if (response.status === 200) {
        const json = response.data || {};
        console.log("Sent back audit data:", json);
        setSentBackAuditData(json);

        console.log("sendback data", json)
        
        // Auto-fill form data with sent back values
        if (json.fields) {
          console.log("All fields from API:", json.fields);
          const updatedFormData = { ...formData };
          Object.keys(json.fields).forEach(fieldKey => {
            console.log(`Processing field: ${fieldKey} with value:`, json.fields[fieldKey].value);
            if (json.fields[fieldKey]?.value !== undefined && json.fields[fieldKey]?.value !== null) {
              // Handle different value formats
              let value = json.fields[fieldKey].value;
              
              // Handle array values (like audit_criteria)
              if (typeof value === 'string' && value.startsWith('[') && value.endsWith(']')) {
                try {
                  value = JSON.parse(value);
                  // For audit_criteria, keep it as an array for multiselect
                  if (fieldKey === 'audit_criteria') {
                    updatedFormData[fieldKey] = value; // Keep as array
                  } else {
                    // If it's an array, take the first value for single-select fields
                    if (Array.isArray(value) && value.length > 0) {
                      value = value[0];
                    }
                  }
                } catch (e) {
                  console.log('Could not parse array value:', value);
                }
              }
              
              // Handle additional_attendee field specifically
              if (fieldKey === 'additional_attendee' && typeof value === 'string') {
                try {
                  const attendeeData = JSON.parse(value);
                  console.log('Parsed additional_attendee data:', attendeeData);
                  // Convert the object to rows format
                  const attendeeRows = Object.entries(attendeeData).map(([name, function_role]) => ({
                    name: name,
                    function: function_role
                  }));
                  console.log('Converted to rows format:', attendeeRows);
                  setRows(attendeeRows);
                  // Don't set this in formData since we're handling it separately
                  return; // Skip setting this in formData
                } catch (e) {
                  console.log('Could not parse additional_attendee value:', value);
                }
              }
              
              // Handle audit_focus_area field specifically
              if (fieldKey === 'audit_focus_area') {
                console.log('Processing audit_focus_area field with value:', value, 'type:', typeof value);
                if (typeof value === 'string') {
                  try {
                    const focusAreaData = JSON.parse(value);
                    console.log('Parsed audit_focus_area data:', focusAreaData);
                    // Set the parsed array to focusAreaField state for UI rendering
                    if (Array.isArray(focusAreaData)) {
                      console.log('Setting focusAreaField to:', focusAreaData);
                      // Ensure we have at least one field, even if the array is empty
                      const fieldsToSet = focusAreaData.length > 0 ? focusAreaData : [""];
                      setFocusAreaField(fieldsToSet);
                      // Also set it in formData as an array
                      updatedFormData[fieldKey] = focusAreaData;
                    }
                    return; // Skip the general processing below
                  } catch (e) {
                    console.log('Could not parse audit_focus_area value:', value, 'Error:', e);
                  }
                } else if (Array.isArray(value)) {
                  console.log('audit_focus_area is already an array:', value);
                  setFocusAreaField(value);
                  updatedFormData[fieldKey] = value;
                  return;
                }
              }
              
              // Handle boolean values
              if (value === 'true') value = true;
              if (value === 'false') value = false;
              
              // Handle date format conversion
              if (fieldKey.includes('date') && typeof value === 'string') {
                try {
                  // Convert "Fri, 18 Jul 2025 00:00:00 GMT" to "2025-07-18"
                  const date = new Date(value);
                  if (!isNaN(date.getTime())) {
                    value = date.toISOString().split('T')[0]; // Format: YYYY-MM-DD
                  }
                } catch (e) {
                  console.log('Could not parse date value:', value);
                }
              }
              
              // Only update if not audit_criteria (since we handled it above)
              if (fieldKey !== 'audit_criteria') {
                updatedFormData[fieldKey] = value;
              }

              if(fieldKey === 'is_fssc_conjunction'){
                updatedFormData[fieldKey] = value ? true : false;
              }
            }
          });
          
          // Special handling for audit_focus_area to ensure it gets processed
          if (json?.fields?.audit_focus_area) {
            console.log("Special handling for audit_focus_area:", json.fields.audit_focus_area);
            const focusAreaValue = json.fields.audit_focus_area.value;
            if (typeof focusAreaValue === 'string') {
              try {
                const focusAreaData = JSON.parse(focusAreaValue);
                console.log('Special parsing - Parsed audit_focus_area data:', focusAreaData);
                if (Array.isArray(focusAreaData)) {
                  console.log('Special parsing - Setting focusAreaField to:', focusAreaData);
                  const fieldsToSet = focusAreaData.length > 0 ? focusAreaData : [""];
                  setFocusAreaField(fieldsToSet);
                  updatedFormData.audit_focus_area = focusAreaData;
                }
              } catch (e) {
                console.log('Special parsing - Could not parse audit_focus_area value:', focusAreaValue, 'Error:', e);
              }
            }
          }
          
          setFormData(updatedFormData);

          console.log("updated form data", updatedFormData)
        }
        
        setSentBackLoading(false);
        setDataLoading(false); // Set dataLoading to false when sent back data is fetched
      }
    } catch (error) {
      setSentBackLoading(false);
      setSentBackError("Failed to fetch sent back audit data");
      console.error("Error fetching sent back audit data:", error);
      
      // Use fallback data if API fails
      console.log("Using fallback data due to API error");
      
    
      
      // Even if there's an error, stop the loading screen so the form can be displayed
      setDataLoading(false);
    }
  };

  // Debug useEffect to monitor focusAreaField changes
  useEffect(() => {
    console.log("focusAreaField changed:", focusAreaField);
  }, [focusAreaField]);

  useEffect(() => {
    if (checkformDataValues) {
      setSubmitDisable(false);
    } else {
      setSubmitDisable(true);
    }
  }, [checkAttendies, checkformDataValues]);

  useEffect(() => {
    // getFormData();
    getSentBackAuditData(); // Fetch sent back audit data
  }, []);

  // Check if a field should be disabled (only "Needs Correction" fields are editable)
  const shouldFieldBeDisabled = (fieldKey) => {
    const status = getFieldStatus(fieldKey);
    
    // Special logic for lead_auditor_function: if lead_auditor needs correction, function should also be editable
    if (fieldKey === "lead_auditor_function") {
      const leadAuditorStatus = getFieldStatus("lead_auditor");
      if (leadAuditorStatus === "Needs Correction") {
        return false; // Make it editable
      }
    }
    
    // Special logic for additional attendee fields: if additional_attendee needs correction, all attendee fields should be editable
    if (fieldKey.startsWith("additional_attendee_")) {
      const additionalAttendeeStatus = getFieldStatus("additional_attendee");
      if (additionalAttendeeStatus === "Needs Correction") {
        return false; // Make it editable
      }
    }
    
    // Special logic for focus area fields: if audit_focus_area needs correction, all focus area fields should be editable
    if (fieldKey.startsWith("audit_focus_area_")) {
      const focusAreaStatus = getFieldStatus("audit_focus_area");
      if (focusAreaStatus === "Needs Correction") {
        return false; // Make it editable
      }
    }
    
    return status !== "Needs Correction";
  };

  // Check if a field needs correction (for red border styling)
  const isFieldNeedingCorrection = (fieldKey) => {
    const status = sentBackAuditData?.fields?.[fieldKey]?.status;
    
    // Special logic for lead_auditor_function: if lead_auditor needs correction, function should also show red border
    if (fieldKey === "lead_auditor_function") {
      const leadAuditorStatus = sentBackAuditData?.fields?.lead_auditor?.status;
      if (leadAuditorStatus === "Needs Correction") {
        return true; // Show red border
      }
    }
    
    // Special logic for additional attendee fields: if additional_attendee needs correction, all attendee fields should show red border
    if (fieldKey.startsWith("additional_attendee_")) {
      const additionalAttendeeStatus = sentBackAuditData?.fields?.additional_attendee?.status;
      if (additionalAttendeeStatus === "Needs Correction") {
        return true; // Show red border
      }
    }
    
    // Special logic for focus area fields: if audit_focus_area needs correction, all focus area fields should show red border
    if (fieldKey.startsWith("audit_focus_area_")) {
      const focusAreaStatus = sentBackAuditData?.fields?.audit_focus_area?.status;
      if (focusAreaStatus === "Needs Correction") {
        return true; // Show red border
      }
    }
    
    return status === "Needs Correction";
  };

  // Get field status for display
  const getFieldStatus = (fieldKey) => {
    return sentBackAuditData?.fields?.[fieldKey]?.status || "Not Reviewed";
  };

 

  const unitDetailsInfo = async () => {
    const viewUrl = `${process.env.REACT_APP_SERVER_URL}/super/view_forms/${auditNumber}`;
    const token = await getToken();
    try {
      setLoading(true);
      const response = await axios.get(viewUrl, {
        headers: {
          "oidc-token": token,
          Accept: "application/json",
        },
      });
      if (response.status === 200) {
        const data = response.data;
        const unit_index = data?.unitIndex;
        const combinedData = [
          ...data.unitDetails.unitDetails,
          ...data.unitDetails.offSiteFields,
        ];
        if (combinedData) {
          setUnitDetails(combinedData);
        }
        if (unit_index) {
          setUnitIndex(unit_index);
        }

        console.log("combine data", combinedData);
      }
    } catch (e) {
      const status = e?.response?.status;
      if (status === 401) {
        login();
      }
      if (status === 500) {
        setError(true);
        setTimeout(() => {
          setError(false);
        }, 3000);
      }

      console.log("getting error while calling the api");
    }
  };

  const getFormData = async () => {
    try {
      setDataLoading(true);

      const url = `${process.env.REACT_APP_SERVER_URL}/api/forms/get_audit/${auditNumber}`;
      const token = await getToken();

      const response = await axios.get(url, {
        headers: {
          "oidc-token": token,
          Accept: "application/json",
        },
      });

      if (response.status === 200) {
        const json = response.data;
        setformDataDownload(json);
        if (json.audit_team) {
          const updatedData = Object.entries(json.audit_team).map(
            ([name, func]) => ({
              name,
              function: func,
            })
          );
          setRows(updatedData);
        }
        if (json?.audit_focus_area) {
          setFocusAreaField(json.audit_focus_area);
        }
        setDataLoading(false);
      }
    } catch (e) {
      setDataLoading(false);
      const status = e?.response?.status;
      if (status === 401) {
        login();
      }
      if (status === 500) {
        setError(true);
        setTimeout(() => {
          setError(false);
        }, 3000);
      }
      console.error("Error while calling the API:", e);
      // setloading(false);
    }
  };

  const transformData = (excelData) => {
    if (typeof excelData !== "object" || excelData === null) {
      console.error("Expected an object but received:", excelData);
      return {};
    }

    const {
      form_id,
      segment,
      uiut,
      phase,
      protocol_type,
      phase_status,
      activity,
    } = excelData;
    return {
      "Audit Number": form_id || "N/A",
      Segment: segment || "N/A",
      "Unit Index + Unit Name": uiut || "N/A",
      "Phase Stage": phase || "N/A",
      "Protocol Type": protocol_type || "N/A",
      "Phase Progress": phase_status || "N/A",
      "Overall Audit Progress": activity || "N/A",
    };
  };

  useEffect(() => {
    unitDetailsInfo();
    getFormData()
  }, []);

  return (
    <>
      {dataLoading ? (
        <Modal open={dataLoading}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
              width: "100%",
              flexDirection: "column",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              backdropFilter: "blur(5px)",
              borderRadius: "10px",
              padding: "20px",
            }}
          >
            <CircularProgress color="secondary" sx={{ marginBottom: "20px" }} />
            <h3
              style={{
                color: "white",
                fontSize: "18px",
                fontWeight: "500",
              }}
            >
              Loading... Please wait
            </h3>
          </Box>
        </Modal>
      ) : (
        <>
          <div id="audit-details-form-component">
          <span style={{ display: "grid", justifyContent: "flex-end" }}>
              <LeadAuditExcel
              
                excelData={formDataDownload}
                fileName={`${unitIndex}_${auditNumber}_${new Date().getTime()}`}
                transformData={transformData}
                sheetName={["Unit Details", "Audit details"]}
                color="ff8200"
                focusArea={focusAreaField}
                additionalAttendees={rows}
                unitDetails={unitDetails}
              />
            </span>
            <form onSubmit={handleSubmit}>
              <div className="form-component-container">
                {/* Left Column */}
                
                {/* CB Office Location */}
                <div className="input-box">
                  <label className="input-label">
                    {AuditAdminData.cbOfficeLocation.label}
                  </label>
                  <Select
                    options={sentBackAuditData?.location?.map(loc => ({ value: loc, label: loc })) || AuditAdminData.cbOfficeLocation.options}
                    value={
                      (sentBackAuditData?.location?.map(loc => ({ value: loc, label: loc })) || AuditAdminData.cbOfficeLocation.options).find(
                        (option) => option.value === formData.cb_office_location
                      ) || null
                    }
                    onChange={(selectedOption) =>
                      handleInputChange(
                        AuditAdminData.cbOfficeLocation.name,
                        selectedOption.value
                      )
                    }
                    isSearchable={true}
                    className={`searchable-select ${isFieldNeedingCorrection("cb_office_location") ? "needs-correction" : ""}`}
                    classNamePrefix="searchable-select"
                    name={AuditAdminData.cbOfficeLocation.name}
                    isDisabled={shouldFieldBeDisabled("cb_office_location")}
                  />
                </div>

                {/* Right Column */}
                
                {/* Audit Language */}
                <div className="input-box">
                  <label className="input-label">
                    {AuditAdminData.auditLanguage.label}
                  </label>
                  <Select
                    options={sentBackAuditData?.language?.map(lang => ({ value: lang, label: lang })) || AuditAdminData.auditLanguage.options}
                    value={
                      (sentBackAuditData?.language?.map(lang => ({ value: lang, label: lang })) || AuditAdminData.auditLanguage.options).find(
                        (option) => option.value === formData.audit_language
                      ) || null
                    }
                    onChange={(selectedOption) =>
                      handleInputChange(
                        AuditAdminData.auditLanguage.name,
                        selectedOption.value
                      )
                    }
                    isSearchable={true}
                    className={`searchable-select ${isFieldNeedingCorrection("audit_language") ? "needs-correction" : ""}`}
                    classNamePrefix="searchable-select"
                    name={AuditAdminData.auditLanguage.name}
                    isDisabled={shouldFieldBeDisabled("audit_language")}
                  />
                </div>

                {/* FSSC Certification Audit */}
                <div className="input-box">
                  <label className="input-label">
                    {AuditAdminData.fsscCertificationAudit.label}
                  </label>
                  <div className={`radio-container ${isFieldNeedingCorrection("is_fssc_conjunction") ? "needs-correction" : ""}`}>
                    {AuditAdminData.fsscCertificationAudit.options.map(
                      (option, idx) => (
                        <label
                          className="radio-field"
                          key={idx}
                          style={{ marginRight: "10px" }}
                        >
                          <input
                            className="radio-circle"
                            type="radio"
                            name={AuditAdminData.fsscCertificationAudit.name}
                            value={option.value}
                            required={
                              AuditAdminData.fsscCertificationAudit.required
                            }
                            checked={
                              sentBackAuditData?.fields?.is_fssc_conjunction?.value === option.value
                            }
                            onChange={() =>
                              handleInputChange(
                                AuditAdminData.fsscCertificationAudit.name,
                                option.value
                              )
                            }
                            disabled={shouldFieldBeDisabled("is_fssc_conjunction")}
                          />
                          <span className="radio-option-text">
                            {option.label}
                          </span>
                        </label>
                      )
                    )}
                  </div>
                </div>

                {/* Audit Criteria */}
                <div className="input-box">
                  <label className="input-label">
                    {AuditAdminData.auditCriteria.label}
                  </label>
                  <Select
                    isMulti
                    options={sentBackAuditData?.standards?.map(standard => ({ value: standard, label: standard })) || AuditAdminData.auditCriteria.options}
                    value={
                      Array.isArray(formData.audit_criteria) 
                        ? formData.audit_criteria.map(criteria => ({ value: criteria, label: criteria }))
                        : []
                    }
                    onChange={(selectedOptions) => {
                      const values = selectedOptions ? selectedOptions.map(option => option.value) : [];
                      handleInputChange(AuditAdminData.auditCriteria.name, values);
                    }}
                    isSearchable={true}
                    className={`searchable-select ${isFieldNeedingCorrection("audit_criteria") ? "needs-correction" : ""}`}
                    classNamePrefix="searchable-select"
                    name={AuditAdminData.auditCriteria.name}
                    isDisabled={shouldFieldBeDisabled("audit_criteria")}
                  />
                  <small style={{ color: '#666', fontSize: '12px', marginTop: '4px' }}>-You can select more than one option</small>
                </div>

                {/* Audit Start Date */}
                <div className="input-box">
                  <label className="input-label">
                    {AuditAdminData.auditStartDate.label}
                  </label>
                  <input
                    className={`input-field ${isFieldNeedingCorrection("audit_start_date") ? "needs-correction" : ""}`}
                    type={AuditAdminData.auditStartDate.type}
                    name={AuditAdminData.auditStartDate.name}
                    placeholder={AuditAdminData.auditStartDate.placeholder}
                    required={AuditAdminData.auditStartDate.required}
                    value={formData.audit_start_date || ""}
                    disabled={shouldFieldBeDisabled("audit_start_date")}
                    onChange={(e) =>
                      handleInputChange(
                        AuditAdminData.auditStartDate.name,
                        e.target.value
                      )
                    }
                  />
                </div>

                {/* Audit End Date */}
                <div className="input-box">
                  <label className="input-label">
                    {AuditAdminData.auditEndDate.label}
                  </label>
                  <input
                    className={`input-field ${isFieldNeedingCorrection("audit_end_date") ? "needs-correction" : ""}`}
                    type={AuditAdminData.auditEndDate.type}
                    placeholder={AuditAdminData.auditEndDate.placeholder}
                    required={AuditAdminData.auditEndDate.required}
                    value={formData.audit_end_date || ""}
                    onChange={(e) =>
                      handleInputChange(
                        AuditAdminData.auditEndDate.name,
                        e.target.value
                      )
                    }
                    name={AuditAdminData.auditEndDate.name}
                    disabled={shouldFieldBeDisabled("audit_end_date")}
                  />
                </div>

                {/* Audit Delivery */}
                <div className="input-box">
                  <label className="input-label">
                    {AuditAdminData.auditDelivery.label}
                  </label>
                  <Select
                    options={AuditAdminData.auditDelivery.options}
                    value={
                      AuditAdminData.auditDelivery.options.find(
                        (option) => option.value === formData.audit_delivery
                      ) || null
                    }
                    onChange={(selectedOption) =>
                      handleInputChange(
                        AuditAdminData.auditDelivery.name,
                        selectedOption.value
                      )
                    }
                    isSearchable={true}
                    className={`searchable-select ${isFieldNeedingCorrection("audit_delivery") ? "needs-correction" : ""}`}
                    classNamePrefix="searchable-select"
                    name={AuditAdminData.auditDelivery.name}
                    isDisabled={shouldFieldBeDisabled("audit_delivery")}
                  />
                </div>

                {/* Audit Type */}
                <div className="input-box">
                  <label className="input-label">
                    {AuditAdminData.auditType.label}
                  </label>
                  <Select
                    options={AuditAdminData.auditType.options}
                    value={
                      AuditAdminData.auditType.options.find(
                        (option) => option.value === formData.audit_type?.toLowerCase()
                      ) || null
                    }
                    onChange={(selectedOption) =>
                      handleInputChange(
                        AuditAdminData.auditType.name,
                        selectedOption.value
                      )
                    }
                    isSearchable={true}
                    className={`searchable-select ${isFieldNeedingCorrection("audit_type") ? "needs-correction" : ""}`}
                    classNamePrefix="searchable-select"
                    name={AuditAdminData.auditType.name}
                    isDisabled={shouldFieldBeDisabled("audit_type")}
                  />
                </div>

               <div>
                 {/* Version */}
                <div className="input-box">
                  <label className="input-label">
                    {AuditAdminData.version.label}
                  </label>
                  <input
                    className={`input-field ${isFieldNeedingCorrection("version") ? "needs-correction" : ""}`}
                    type={AuditAdminData.version.type}
                    name={AuditAdminData.version.name}
                    placeholder={AuditAdminData.version.placeholder}
                    required={AuditAdminData.version.required}
                    value={formData.version || ""}
                    disabled={shouldFieldBeDisabled("version")}
                    onChange={(e) =>
                      handleInputChange(
                        AuditAdminData.version.name,
                        e.target.value
                      )
                    }
                  />
                </div>
                   {/* Job Number */}
                <div className="input-box pt-[10px]" >
                  <label className="input-label">
                    {AuditAdminData.jobnumber.label} 
                    <span className="required-red-text">*</span>
                  </label>
                  <input
                    className="input-field"
                    type={AuditAdminData.jobnumber.type}
                    name={AuditAdminData.jobnumber.name}
                    placeholder={AuditAdminData.jobnumber.placeholder}
                    required={AuditAdminData.jobnumber.required}
                    value={formData.jobnumber || ""}
                    disabled={shouldFieldBeDisabled("jobnumber")}

                    onChange={(e) =>
                      handleInputChange(
                        AuditAdminData.jobnumber.name,
                        e.target.value
                      )
                    }
                  />
                </div>
               </div>

                {/* Audit Team */}
                <div className="input-box">
                  <label className="input-label">
                    Audit Team <span className="required-asterisk">*</span>
                  </label>
                  
                  {/* Audit Team Grid Layout */}
                  <div className="audit-team-grid">
                    {/* Left Column - Text Inputs */}
                    <div className="audit-team-left-column">
                      <input
                        className={`input-field ${isFieldNeedingCorrection("lead_auditor") ? "needs-correction" : ""}`}
                        type="text"
                        placeholder="Lead Auditor Name"
                        value={formData.lead_auditor || ""}
                        name="lead_auditor"
                        onChange={(e) =>
                          handleInputChange("lead_auditor", e.target.value)
                        }
                        disabled={shouldFieldBeDisabled("lead_auditor")}
                      />
                      
                      {rows.map((row, index) => (
                        <input
                          key={index}
                          className={`input-field ${isFieldNeedingCorrection(`additional_attendee_${index}_name`) ? "needs-correction" : ""}`}
                          type="text"
                          placeholder="Additional Attendees Name"
                          value={row.name}
                          onChange={(e) =>
                            handleRowChange(index, "name", e.target.value)
                          }
                          disabled={shouldFieldBeDisabled(`additional_attendee_${index}_name`)}
                        />
                      ))}
                    </div>
                    
                    {/* Right Column - Dropdowns */}
                    <div className="audit-team-right-column">
                      <select
                        className={`input-field ${isFieldNeedingCorrection("lead_auditor_function") ? "needs-correction" : ""}`}
                        value={formData.lead_auditor_function || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "lead_auditor_function",
                            e.target.value
                          )
                        }
                        disabled={shouldFieldBeDisabled("lead_auditor_function")}
                      >
                        <option value="" disabled>
                          Select Lead Auditor
                        </option>
                        <option value="Lead Auditor">Lead Auditor</option>
                      </select>
                      
                      {rows.map((row, index) => (
                        <div key={index} className="attendee-dropdown-row">
                          <select
                            className={`input-field ${isFieldNeedingCorrection(`additional_attendee_${index}_function`) ? "needs-correction" : ""}`}
                            value={row.function}
                            onChange={(e) =>
                              handleRowChange(index, "function", e.target.value)
                            }
                            disabled={shouldFieldBeDisabled(`additional_attendee_${index}_function`)}
                          >
                            <option value="" disabled>
                              Select Additional Attendees
                            </option>
                            <option value="Team Member">Team Member</option>
                            <option value="Observer">Observer</option>
                            <option value="Witness">Witness</option>
                          </select>
                          
                          {/* Remove Button - Only for additional attendees */}
                          <button
                            type="button"
                            onClick={() => {
                              const newRows = rows.filter((_, i) => i !== index);
                              setRows(newRows);
                            }}
                            className="remove-attendee-btn"
                            title="Remove attendee"
                            disabled={shouldFieldBeDisabled(`additional_attendee_${index}_name`)}
                          >
                            ×
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                  
                  {/* Add More Attendees Button */}
                  {(!shouldFieldBeDisabled("additional_attendee_0_name") || getFieldStatus("additional_attendee") === "Needs Correction") && (
                    <div className="add-icon">
                      <IconButton 
                        onClick={addRow} 
                        disabled={rows.length >= 5}
                        className="add-attendee-btn"
                      >
                        <AddCircleIcon />
                      </IconButton>
                      <span>Add more attendees</span>
                    </div>
                  )}
                </div>

                {/* Audit Focus Area */}
                <div className="input-box">
                  <label className="input-label">
                    {AuditAdminData.auditFocusArea.label}
                  </label>
                  {focusAreaField?.map((item, index) => (
                    <input
                      className={`input-field ${isFieldNeedingCorrection(`audit_focus_area_${index}`) ? "needs-correction" : ""}`}
                      type={AuditAdminData.auditFocusArea.type}
                      name="auditFocusArea"
                      placeholder={AuditAdminData.auditFocusArea.placeholder}
                      required={AuditAdminData.auditFocusArea.required}
                      value={focusAreaField[index] || ""}
                      onChange={(e) =>
                        handleFocusAreaChange(index, e.target.value)
                      }
                      disabled={shouldFieldBeDisabled(`audit_focus_area_${index}`)}
                    />
                  ))}
                  <div className="add-icon">
                    {(!shouldFieldBeDisabled("audit_focus_area_0") || getFieldStatus("audit_focus_area") === "Needs Correction") && (
                      <>
                        <IconButton
                          onClick={addFocusAreaRows}
                          disabled={focusAreaField.length >= 4}
                        >
                          <AddCircleIcon />
                        </IconButton>
                        <span>+ Add another row</span>
                      </>
                    )}
                  </div>
                </div>

                {/* Corrective Action Date - Added at the end as requested */}
                {
                  formData && formData.version && formData.version !==1 && (

                    <div className="input-box">
                    <label className="input-label">
                      {AuditAdminData.correctiveActionDate.label}
                    </label>
                    <input
                      className={`input-field ${isFieldNeedingCorrection("corrective_action_date") ? "needs-correction" : ""}`}
                      type={AuditAdminData.correctiveActionDate.type}
                      name={AuditAdminData.correctiveActionDate.name}
                      placeholder={AuditAdminData.correctiveActionDate.placeholder}
                      required={AuditAdminData.correctiveActionDate.required}
                      value={formData.corrective_action_date || ""}
                      disabled={shouldFieldBeDisabled("corrective_action_date")}
                      onChange={(e) =>
                        handleInputChange(
                          AuditAdminData.correctiveActionDate.name,
                          e.target.value
                        )
                      }
                    />
                  </div>
                    
                  )
                }
               
              </div>
            </form>
          </div>
          
          <div className="bottom-container">
            <div className="required-text">
              Fields marked <span>*</span> are Required.
            </div>
            <div id="action-button-container">
              {loading.save ? (
                <button className="action-btn" disabled>
                  Loading...
                </button>
              ) : (
                <button
                  onClick={() => {
                    submitForm("saved");
                  }}
                  className="action-btn"
                >
                  Save
                </button>
              )}
              {loading.submit ? (
                <button className="action-btn" disabled>
                  Loading...
                </button>
              ) : (
                <button
                  onClick={() => {
                    submitForm("completed");
                  }}
                  className="action-btn"
                  disabled={submitDisable}
                >
                  Next
                </button>
              )}
            </div>
          </div>
          
          <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            open={open}
            onClose={handleClose}
            message={snackbarMessage}
            autoHideDuration={2000}
            className="success-snackbar"
          />
        </>
      )}
    </>
  );
};

export default FormComponent;